import * as React from 'react';
export var CloseIcon = function (props) {
    var onClick = props.onClick, className = props.className;
    var iconHandler = React.useCallback(function (prev) { return onClick(!prev); }, []);
    return (React.createElement("div", { onClick: iconHandler, className: className },
        React.createElement("svg", { width: "15", height: "14", viewBox: "0 0 15 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.6751 0L7.5 6.17512L1.32485 0L0.5 0.824852L6.67515 7L0.5 13.1751L1.32485 14L7.5 7.82485L13.6751 14L14.5 13.1751L8.32485 7L14.5 0.824852L13.6751 0Z", fill: "#121212" }))));
};
